import {useContext} from 'react';
import {DARK_THEME, LIGHT_THEME, ThemeContext} from "../../contexts/ThemeContext";
import {styles, themes} from "./Theme";
import SwitcherCheckbox from "../UI/Checkboxes/SwitcherCheckbox";
import {Sun} from "@styled-icons/evaicons-solid/Sun"
import {Moon} from "@styled-icons/boxicons-regular/Moon"

const ThemeSwitcher = () => {
  const { theme, toggleTheme } = useContext(ThemeContext);

  return (
    <div>
      <SwitcherCheckbox
        isChecked={theme === DARK_THEME}
        onChange={toggleTheme}
        icon={theme === themes.dark
          ? <Moon color={styles.colors.darkOnyx}/>
          : <Sun color={'#ffd200'} />
        }
      />
    </div>
  );
};

export default ThemeSwitcher;